import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import DescriptionIcon from '@material-ui/icons/Description';
import ArrowDropDownCircleRoundedIcon from '@material-ui/icons/ArrowDropDownCircleRounded';
import { Typography, Link, Tooltip } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '4px 22px',
    backgroundColor: '#cccccc',
    // color: '#1f2835',
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 'bold',
    borderRadius: 20,
  },
  icon: {
    marginRight: 12,
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    height: 42,
    borderBottom: '1px solid #ffffff',
    paddingBottom: 12,
    paddingTop: 12,
  },
  url: {
    display: 'flex',
    alignItems: 'center',
    height: 42,
    paddingTop: 12,
    paddingBottom: 12,
  },
  characteristicsUnits: {
    maxWidth: 200,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 100,
    },
    display: 'none',
  },
}));

const NewsDocCard = (props) => {
  const { title, url, urlText, className, buttonText, ...rest } = props; // eslint-disable-line no-unused-vars
  const classes = useStyles();
  
  return (
    <div className={clsx(classes.root, className)}>
      <div className={classes.title}>
        <DescriptionIcon className={classes.icon} />
        <Tooltip title={title}>
          <Typography variant='body' component='div'>
            {title.length > 22 ? `${title.substring(0, 21)}...` : title}
          </Typography>
        </Tooltip>
      </div>
      <div className={classes.url}>
        <ArrowDropDownCircleRoundedIcon className={classes.icon} />
        <Link href={url} target='_blank'>
          {urlText}
        </Link>
      </div>
    </div>
  );
};

NewsDocCard.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * Doc title to view
   */
  title: PropTypes.string,
  /**
   * Doc url where to download
   */
  url: PropTypes.string,
  /**
   * Doc url title to show
   */
  urlText: PropTypes.string,
};

export default NewsDocCard;
